<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
        <g fill="none" fill-rule="evenodd">
            <g>
                <g transform="translate(-544 -400) translate(545 401)">
                    <circle cx="6" cy="6" r="6" fill="#FFF" stroke="#333"/>
                    <circle cx="6" cy="6" r="3.429" fill="#333"/>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'radio-check'
}
</script>
